<rt-box variant="default vertical no-padding" margin-bottom>
  <div layout-vertical>
    <rt-interview-result-summary-overall
      [groups]="groups"
      [results]="results ?? []"
      [candidate]="candidate"
      [lastUpdate]="lastUpdate"
      [offerId]="offerId"
      [currentUserAvailablePlacements]="currentUserAvailablePlacements"
      [hasAccessToAllJobOffers]="hasAccessToAllJobOffers"
      (summaryResultCounterClick)="summaryResultCounterClick.emit($event)"
    >
    </rt-interview-result-summary-overall>
  </div>
</rt-box>

@if (scorecardsResults.length > 0) {
  <rt-box variant="default vertical no-padding" margin-bottom>
    <div layout-horizontal>
      <div
        class="box-header"
        padding-left
        padding-tb-small
        layout-horizontal
        layout-space-between
        layout-flex-1
      >
        <rt-heading variant="subheading">
          {{ 'app.interview.summary.scorecards_summary' | translate }}
        </rt-heading>
      </div>
    </div>

    <rt-divider></rt-divider>
    <div layout-vertical>
      <rt-interview-result-summary-scorecards
        [hasHiddenResults]="!!hiddenResultsPreview?.length"
        [scorecardsResults]="scorecardsResults"
      >
      </rt-interview-result-summary-scorecards>
    </div>
  </rt-box>
}
